(() => {
  const html = document.documentElement;
  const header = document.querySelector(".site-header");
  const menu = document.getElementById("menu");
  const cart = document.getElementById("cart");
  const guide = document.getElementById("guide");
  const search = document.getElementById("search");
  const overlay = document.querySelector("#overlay");
  const shopBtn = document.querySelector("[data-open=menu]");
  const bagBtn = document.querySelector("[data-open=cart]");
  const searchBtn = document.querySelector(".nav-right [data-open=search], [data-open=search]");
  const searchBtns = document.querySelectorAll("[data-open=search]");
  const menuClose = menu?.querySelector("[data-close]");
  const cartClose = cart?.querySelector("[data-close]");
  const guideClose = guide?.querySelector("[data-close]");
  const searchInput = search?.querySelector("[data-search-input]");
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const setAppHeight = () => {
    const h = window.visualViewport?.height || window.innerHeight;
    html.style.setProperty("--app-height", `${Math.round(h)}px`);
  };
  setAppHeight();
  window.visualViewport?.addEventListener("resize", setAppHeight);
  window.addEventListener("orientationchange", setAppHeight);

  let main = document.getElementById("main");
  let pdpBar = document.querySelector("[data-pdp-bar]");
  let footWrap = document.querySelector(".foot-wrap, .shopify-section-group-footer-group");
  let hero = document.querySelector(".hero");
  let layers = document.querySelectorAll("[data-parallax]");
  let atcIo;
  let atcOnScroll;
  let atcSizeAbort;

  const closeSizeMenu = () => {
    document.querySelectorAll("[data-atc-size]").forEach((wrap) => wrap.classList.remove("is-open"));
    document.querySelectorAll("[data-atc-size-toggle]").forEach((t) => t.setAttribute("aria-expanded", "false"));
    document.querySelectorAll("[data-atc-size-menu]").forEach((m) => m.setAttribute("hidden", ""));
  };

  const isDesktopAtc = () => window.matchMedia("(min-width: 901px)").matches;

  const homeBuyRow = (row) => {
    const hold = document.querySelector("[data-buy-hold]");
    if (row && hold && row.parentNode !== hold) hold.appendChild(row);
  };

  const liftBuyRow = (row) => {
    const host = document.querySelector(".site") || pdpBar?.parentNode;
    if (!row || !host || row.parentNode === host) return;
    host.appendChild(row);
  };

  const setAtcBar = (show) => {
    const buyRow = document.querySelector("[data-buy-row]");
    html.classList.toggle("is-atc-bar", show);
    if (!isDesktopAtc()) {
      homeBuyRow(buyRow);
    } else if (show) {
      liftBuyRow(buyRow);
    } else {
      homeBuyRow(buyRow);
    }
    if (!show) {
      closeSizeMenu();
      html.classList.remove("is-atc-full");
      html.style.removeProperty("--atc-scrub");
      pdpBar?.style.setProperty("--atc-scrub", "110%");
    }
    if (!pdpBar) return;
    pdpBar.classList.toggle("is-on", show);
    pdpBar.setAttribute("aria-hidden", show ? "false" : "true");
  };

  const moneyFormat = window.shop_money_format || "£{{amount}}";

  const formatMoney = (cents) => {
    const amount = (Number(cents) / 100).toFixed(2);
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(Number(cents) / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace(".", ","));
  };

  const setPageInert = (on) => {
    header?.toggleAttribute("inert", on);
    main?.toggleAttribute("inert", on);
    footWrap?.toggleAttribute("inert", on);
    pdpBar?.toggleAttribute("inert", on);
  };

  const focusEl = (el) => {
    el?.focus({ preventScroll: true });
  };

  let scrollLocked = false;
  const blockPageScroll = (e) => {
    if (e.target.closest?.(".guide-body, .guide-panel, .guide-finder, .cart-body, .menu, .menu-fly, .search-hits, .search-input")) return;
    e.preventDefault();
  };
  const setScrollLock = (on) => {
    if (on === scrollLocked) return;
    scrollLocked = on;
    const opts = { passive: false };
    if (on) {
      document.addEventListener("wheel", blockPageScroll, opts);
      document.addEventListener("touchmove", blockPageScroll, opts);
    } else {
      document.removeEventListener("wheel", blockPageScroll, opts);
      document.removeEventListener("touchmove", blockPageScroll, opts);
    }
  };

  const flyBtns = document.querySelectorAll("#menu [data-fly]");
  const flies = document.querySelectorAll(".menu-fly");
  let flyTimer;
  const isMobileMenu = () => window.matchMedia("(max-width: 900px)").matches;
  let menuSubBack;
  let menuSubTitle;
  let menuSubNav;

  if (menu && !menu.querySelector(".menu-pane")) {
    const slide = document.createElement("div");
    slide.className = "menu-slide";
    const pane = document.createElement("div");
    pane.className = "menu-pane";
    const foot = document.createElement("div");
    foot.className = "menu-foot";
    [...menu.children].forEach((el) => {
      if (
        el.classList.contains("menu-promo-carousel") ||
        el.classList.contains("menu-secondary") ||
        el.classList.contains("menu-legal") ||
        el.classList.contains("menu-utility")
      ) {
        foot.appendChild(el);
      } else {
        pane.appendChild(el);
      }
    });
    const sub = document.createElement("div");
    sub.className = "menu-sub";
    sub.setAttribute("aria-hidden", "true");
    sub.innerHTML = `
      <div class="menu-head">
        <button class="menu-x" type="button" data-fly-back aria-label="Back">
          <svg viewBox="0 0 12 12" aria-hidden="true"><path d="M8 2.5L3.5 6 8 9.5"/></svg>
        </button>
        <p class="menu-sub-title" data-menu-sub-title></p>
      </div>
      <nav class="menu-nav" data-menu-sub-nav aria-label="Categories"></nav>
    `;
    slide.append(pane, sub);
    menu.append(slide, foot);
    menuSubBack = sub.querySelector("[data-fly-back]");
    menuSubTitle = sub.querySelector("[data-menu-sub-title]");
    menuSubNav = sub.querySelector("[data-menu-sub-nav]");
  }

  document.querySelectorAll("[data-menu-promos]").forEach((carousel) => {
    const track = carousel.querySelector("[data-promo-track]");
    const slides = [...carousel.querySelectorAll("[data-promo-slide]")];
    const dots = [...carousel.querySelectorAll("[data-promo-dot]")];
    const speed = Math.max(3000, Number(carousel.dataset.speed) || 5000);
    const autoplay = carousel.dataset.autoplay === "true" && !reduceMotion;
    let index = 0;
    let timer;
    let pointerX;
    let swiped = false;

    const show = (next) => {
      index = (next + slides.length) % slides.length;
      track?.style.setProperty("--promo-index", String(index));
      slides.forEach((slide, i) => {
        slide.setAttribute("aria-hidden", i === index ? "false" : "true");
        if (i === index) slide.removeAttribute("tabindex");
        else slide.setAttribute("tabindex", "-1");
      });
      dots.forEach((dot, i) => {
        dot.classList.toggle("is-active", i === index);
        if (i === index) dot.setAttribute("aria-current", "true");
        else dot.removeAttribute("aria-current");
      });
    };
    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      if (autoplay && slides.length > 1) {
        timer = window.setInterval(() => show(index + 1), speed);
      }
    };

    dots.forEach((dot) => {
      dot.addEventListener("click", () => {
        show(Number(dot.dataset.promoDot) || 0);
        start();
      });
    });
    carousel.addEventListener("mouseenter", stop);
    carousel.addEventListener("mouseleave", start);
    carousel.addEventListener("focusin", stop);
    carousel.addEventListener("focusout", (e) => {
      if (!carousel.contains(e.relatedTarget)) start();
    });
    carousel.addEventListener("pointerdown", (e) => {
      pointerX = e.clientX;
    });
    carousel.addEventListener("pointerup", (e) => {
      if (pointerX == null || Math.abs(e.clientX - pointerX) < 35) return;
      swiped = true;
      show(index + (e.clientX < pointerX ? 1 : -1));
      pointerX = null;
      start();
    });
    carousel.addEventListener("pointercancel", () => { pointerX = null; });
    carousel.addEventListener("click", (e) => {
      if (!swiped) return;
      e.preventDefault();
      e.stopPropagation();
      swiped = false;
    }, true);

    show(0);
    start();
  });

  document.querySelectorAll("[data-promise-strip]").forEach((strip) => {
    const track = strip.querySelector(".pdp-promises-track");
    const slides = [...strip.querySelectorAll(".pdp-promises article")];
    const dots = [...strip.querySelectorAll("[data-promise-dot]")];
    const speed = Math.max(3000, Number(strip.dataset.speed) || 4200);
    const autoplay = strip.dataset.autoplay === "true" && !reduceMotion;
    let index = 0;
    let pointerX;

    strip.style.setProperty("--promise-speed", `${speed}ms`);

    const restartProgress = () => {
      const span = dots[index]?.querySelector("span");
      if (!span || !autoplay) return;
      span.style.animation = "none";
      void span.offsetWidth;
      span.style.animation = "";
    };
    const show = (next) => {
      index = (next + slides.length) % slides.length;
      track?.style.setProperty("--promise-index", String(index));
      slides.forEach((slide, i) => {
        slide.setAttribute("aria-hidden", i === index ? "false" : "true");
      });
      dots.forEach((dot, i) => {
        const on = i === index;
        dot.classList.toggle("is-active", on);
        if (on) dot.setAttribute("aria-current", "true");
        else dot.removeAttribute("aria-current");
      });
      restartProgress();
    };
    const pause = () => strip.classList.add("is-paused");
    const resume = () => strip.classList.remove("is-paused");

    dots.forEach((dot) => {
      dot.addEventListener("click", () => show(Number(dot.dataset.promiseDot) || 0));
      dot.querySelector("span")?.addEventListener("animationend", () => {
        if (!autoplay || !dot.classList.contains("is-active") || strip.classList.contains("is-paused")) return;
        show(index + 1);
      });
    });
    strip.addEventListener("mouseenter", pause);
    strip.addEventListener("mouseleave", resume);
    strip.addEventListener("focusin", pause);
    strip.addEventListener("focusout", (e) => {
      if (!strip.contains(e.relatedTarget)) resume();
    });
    strip.addEventListener("pointerdown", (e) => {
      if (e.target.closest("[data-promise-dot]")) {
        pointerX = null;
        return;
      }
      pointerX = e.clientX;
    });
    strip.addEventListener("pointerup", (e) => {
      if (pointerX == null || Math.abs(e.clientX - pointerX) < 35) return;
      show(index + (e.clientX < pointerX ? 1 : -1));
      pointerX = null;
    });
    strip.addEventListener("pointercancel", () => { pointerX = null; });

    show(0);
  });

  document.querySelectorAll("[data-featured-carousel]").forEach((root) => {
    const slides = [...root.querySelectorAll("[data-featured-slide]")];
    const pairs = [...root.querySelectorAll("[data-featured-pair]")];
    const medias = [...root.querySelectorAll("[data-featured-media]")];
    const dots = [...root.querySelectorAll("[data-featured-dot]")];
    if (slides.length < 2) return;

    const speed = Math.max(3000, Number(root.dataset.speed) || 5000);
    const autoplay = root.dataset.autoplay === "true" && !reduceMotion;
    let index = 0;
    let pointerX;
    let swiped = false;

    root.style.setProperty("--featured-speed", `${speed}ms`);

    const restartProgress = () => {
      const span = dots[index]?.querySelector("span");
      if (!span || !autoplay) return;
      span.style.animation = "none";
      void span.offsetWidth;
      span.style.animation = "";
    };
    const show = (next) => {
      index = (next + slides.length) % slides.length;
      const sets = [slides, pairs, medias];
      sets.forEach((group) => {
        group.forEach((el, i) => {
          const on = i === index;
          el.classList.toggle("is-active", on);
          el.toggleAttribute("inert", !on);
          el.setAttribute("aria-hidden", on ? "false" : "true");
        });
      });
      dots.forEach((dot, i) => {
        const on = i === index;
        dot.classList.toggle("is-active", on);
        dot.setAttribute("aria-selected", on ? "true" : "false");
      });
      root.classList.toggle("is-ink-dark", slides[index].classList.contains("is-dark"));
      restartProgress();
    };

    root.querySelector("[data-featured-prev]")?.addEventListener("click", () => show(index - 1));
    root.querySelector("[data-featured-next]")?.addEventListener("click", () => show(index + 1));
    dots.forEach((dot) => {
      dot.addEventListener("click", () => show(Number(dot.dataset.featuredDot) || 0));
      dot.querySelector("span")?.addEventListener("animationend", () => {
        if (!autoplay || !dot.classList.contains("is-active") || root.classList.contains("is-paused")) return;
        show(index + 1);
      });
    });
    root.addEventListener("mouseenter", () => root.classList.add("is-paused"));
    root.addEventListener("mouseleave", () => root.classList.remove("is-paused"));
    root.addEventListener("focusin", () => root.classList.add("is-paused"));
    root.addEventListener("focusout", (e) => {
      if (!root.contains(e.relatedTarget)) root.classList.remove("is-paused");
    });
    root.addEventListener("pointerdown", (e) => {
      if (e.target.closest("[data-featured-dot], a, button")) {
        pointerX = null;
        return;
      }
      pointerX = e.clientX;
    });
    root.addEventListener("pointerup", (e) => {
      if (pointerX == null || Math.abs(e.clientX - pointerX) < 35) return;
      swiped = true;
      show(index + (e.clientX < pointerX ? 1 : -1));
      pointerX = null;
    });
    root.addEventListener("pointercancel", () => { pointerX = null; });
    root.addEventListener("click", (e) => {
      if (!swiped) return;
      e.preventDefault();
      e.stopPropagation();
      swiped = false;
    }, true);

    show(0);
  });

  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-open-newsletter]");
    if (!btn) return;
    closeAll();
    window.setTimeout(() => {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(["openForm", "TAm7sJ"]);
      if (window.klaviyo || document.querySelector('script[src*="klaviyo"]')) return;
      const forms = [...document.querySelectorAll("shopify-forms-embed")];
      for (const form of forms) {
        form.setAttribute("reveal", "true");
        const teaser = form.shadowRoot?.querySelector('button[class*="_teaser"]');
        if (teaser) {
          teaser.click();
          return;
        }
      }
      if (window.KING?.Popup?._show) {
        window.KING.Popup._show();
      } else {
        document.querySelector("#shopify-section-popup")?.classList.add("active");
      }
    }, reduceMotion ? 0 : 280);
  });

  const paintMenuSub = (name) => {
    const fly = [...flies].find((el) => el.dataset.fly === name);
    if (menuSubTitle) menuSubTitle.textContent = fly?.getAttribute("aria-label") || "";
    if (!menuSubNav) return;
    menuSubNav.innerHTML = [...(fly?.querySelectorAll(".menu-fly-card") || [])].map((a) => {
      const label = (a.querySelector("span")?.textContent || "").trim();
      const href = a.getAttribute("href") || "#";
      return `<a class="menu-link" href="${href}"><span>${label}</span></a>`;
    }).join("");
  };

  const closeFly = () => {
    clearTimeout(flyTimer);
    html.classList.remove("is-menu-drill");
    menu?.querySelector(".menu-sub")?.setAttribute("aria-hidden", "true");
    flies.forEach((el) => {
      el.classList.remove("is-on");
      el.setAttribute("aria-hidden", "true");
    });
    flyBtns.forEach((el) => {
      el.classList.remove("is-hot");
      el.setAttribute("aria-expanded", "false");
    });
  };

  const openFly = (name) => {
    clearTimeout(flyTimer);
    const mobile = isMobileMenu();
    html.classList.toggle("is-menu-drill", mobile);
    menu?.querySelector(".menu-sub")?.setAttribute("aria-hidden", mobile ? "false" : "true");
    if (mobile) paintMenuSub(name);
    flies.forEach((el) => {
      const on = !mobile && el.dataset.fly === name;
      el.classList.toggle("is-on", on);
      el.setAttribute("aria-hidden", on ? "false" : "true");
    });
    flyBtns.forEach((el) => {
      const on = el.dataset.fly === name;
      el.classList.toggle("is-hot", on);
      el.setAttribute("aria-expanded", on ? "true" : "false");
    });
    if (mobile) focusEl(menuSubBack);
  };

  document.addEventListener("pointerover", (e) => {
    if (!html.classList.contains("is-menu-open") || isMobileMenu()) return;
    const trigger = e.target.closest("#menu [data-fly]");
    if (trigger) {
      openFly(trigger.dataset.fly);
      return;
    }
    if (e.target.closest(".menu-fly")) {
      clearTimeout(flyTimer);
      return;
    }
    const other = e.target.closest("#menu .menu-link, #menu .menu-contact, #menu .menu-legal, #menu .menu-x");
    if (other) {
      closeFly();
      return;
    }
    if (e.target.closest("#menu")) {
      clearTimeout(flyTimer);
      return;
    }
    clearTimeout(flyTimer);
    flyTimer = setTimeout(closeFly, 140);
  });

  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-fly-back]")) {
      e.preventDefault();
      const trigger = document.querySelector("#menu [data-fly].is-hot");
      closeFly();
      focusEl(trigger || menuClose);
      return;
    }
    if (!isMobileMenu() || !html.classList.contains("is-menu-open")) return;
    const trigger = e.target.closest(".menu-pane [data-fly]");
    if (!trigger) return;
    e.preventDefault();
    openFly(trigger.dataset.fly);
  });

  window.matchMedia("(max-width: 900px)").addEventListener("change", closeFly);

  const setGuideBtn = (on) => {
    document.querySelectorAll("[data-open=guide]").forEach((el) => {
      el.setAttribute("aria-expanded", on ? "true" : "false");
    });
  };

  const closeFinder = () => {
    const panel = guide?.querySelector(".guide-panel");
    const finder = guide?.querySelector("[data-finder]");
    const error = finder?.querySelector("[data-finder-error]");
    const title = document.getElementById("guide-title");
    panel?.classList.remove("is-finder");
    if (finder) {
      finder.hidden = true;
      finder.setAttribute("aria-hidden", "true");
    }
    if (error) {
      error.hidden = true;
      error.textContent = "";
    }
    if (title) title.textContent = "Size guide";
  };

  const closeAll = () => {
    const cartWasOpen = cart?.classList.contains("is-open");
    const menuWasOpen = menu?.classList.contains("is-open");
    const guideWasOpen = guide?.classList.contains("is-open");
    const searchWasOpen = search?.classList.contains("is-open");
    closeFinder();
    closeFly();
    menu?.classList.remove("is-open");
    cart?.classList.remove("is-open");
    guide?.classList.remove("is-open");
    search?.classList.remove("is-open");
    overlay?.classList.remove("is-on");
    header?.classList.remove("is-open");
    html.classList.remove("is-cart-open", "is-menu-open", "is-guide-open", "is-search-open");
    setPageInert(false);
    setScrollLock(false);
    menu?.setAttribute("aria-hidden", "true");
    cart?.setAttribute("aria-hidden", "true");
    guide?.setAttribute("aria-hidden", "true");
    search?.setAttribute("aria-hidden", "true");
    shopBtn?.setAttribute("aria-expanded", "false");
    shopBtn?.setAttribute("aria-label", "Shop");
    bagBtn?.setAttribute("aria-expanded", "false");
    searchBtns.forEach((btn) => btn.setAttribute("aria-expanded", "false"));
    setGuideBtn(false);
    if (cartWasOpen) focusEl(bagBtn);
    else if (menuWasOpen) focusEl(shopBtn);
    else if (guideWasOpen) focusEl(document.querySelector("[data-open=guide]"));
    else if (searchWasOpen) focusEl(searchBtn);
  };

  const openMenu = () => {
    setAppHeight();
    html.classList.remove("is-cart-open", "is-guide-open", "is-search-open");
    cart?.classList.remove("is-open");
    guide?.classList.remove("is-open");
    search?.classList.remove("is-open");
    header?.classList.remove("is-open");
    menu?.classList.add("is-open");
    overlay?.classList.add("is-on");
    html.classList.add("is-menu-open");
    setPageInert(true);
    setScrollLock(true);
    menu?.setAttribute("aria-hidden", "false");
    cart?.setAttribute("aria-hidden", "true");
    guide?.setAttribute("aria-hidden", "true");
    search?.setAttribute("aria-hidden", "true");
    shopBtn?.setAttribute("aria-expanded", "true");
    shopBtn?.setAttribute("aria-label", "Close menu");
    bagBtn?.setAttribute("aria-expanded", "false");
    searchBtns.forEach((btn) => btn.setAttribute("aria-expanded", "false"));
    setGuideBtn(false);
    focusEl(menuClose);
  };

  const openCart = () => {
    html.classList.remove("is-menu-open", "is-guide-open", "is-search-open");
    menu?.classList.remove("is-open");
    guide?.classList.remove("is-open");
    search?.classList.remove("is-open");
    shopBtn?.setAttribute("aria-expanded", "false");
    shopBtn?.setAttribute("aria-label", "Shop");
    header?.classList.remove("is-open");
    cart?.classList.add("is-open");
    overlay?.classList.add("is-on");
    html.classList.add("is-cart-open");
    setPageInert(true);
    setScrollLock(true);
    menu?.setAttribute("aria-hidden", "true");
    cart?.setAttribute("aria-hidden", "false");
    guide?.setAttribute("aria-hidden", "true");
    search?.setAttribute("aria-hidden", "true");
    bagBtn?.setAttribute("aria-expanded", "true");
    searchBtns.forEach((btn) => btn.setAttribute("aria-expanded", "false"));
    setGuideBtn(false);
    focusEl(cartClose);
  };

  const syncGuideScroll = () => {
    const frame = guide?.querySelector("[data-guide-scroll]");
    const wrap = frame?.querySelector(".guide-table-wrap");
    if (!frame || !wrap) return;
    const overflow = wrap.scrollWidth - wrap.clientWidth > 8;
    const atEnd = wrap.scrollLeft + wrap.clientWidth >= wrap.scrollWidth - 8;
    frame.classList.toggle("is-overflow", overflow && !atEnd);
    frame.classList.toggle("is-scrolled", wrap.scrollLeft > 12);
  };

  const openGuide = () => {
    html.classList.remove("is-cart-open", "is-menu-open", "is-search-open");
    cart?.classList.remove("is-open");
    menu?.classList.remove("is-open");
    search?.classList.remove("is-open");
    shopBtn?.setAttribute("aria-expanded", "false");
    shopBtn?.setAttribute("aria-label", "Shop");
    bagBtn?.setAttribute("aria-expanded", "false");
    header?.classList.remove("is-open");
    guide?.classList.add("is-open");
    overlay?.classList.add("is-on");
    html.classList.add("is-guide-open");
    setPageInert(true);
    setScrollLock(true);
    menu?.setAttribute("aria-hidden", "true");
    cart?.setAttribute("aria-hidden", "true");
    guide?.setAttribute("aria-hidden", "false");
    search?.setAttribute("aria-hidden", "true");
    searchBtns.forEach((btn) => btn.setAttribute("aria-expanded", "false"));
    setGuideBtn(true);
    window.requestAnimationFrame(() => window.requestAnimationFrame(syncGuideScroll));
    focusEl(guideClose);
  };

  let searchSuggest = [];
  try {
    const raw = search?.querySelector("[data-search-suggest]")?.textContent;
    searchSuggest = raw ? JSON.parse(raw) : [];
  } catch {
    searchSuggest = [];
  }

  const escapeHtml = (s) => String(s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");

  let searchActiveIndex = -1;
  const searchUrl = window.search_url || "/search";
  const searchPageHref = (q) =>
    q ? `${searchUrl}?q=${encodeURIComponent(q)}&type=product&options%5Bprefix%5D=last` : searchUrl;

  const renderSearchHits = (items, query) => {
    const kicker = search?.querySelector("[data-search-kicker]");
    const hits = search?.querySelector("[data-search-hits]");
    const chips = search?.querySelector("[data-search-chips]");
    if (!hits) return;
    const q = query.trim();
    searchActiveIndex = -1;
    if (chips) chips.hidden = Boolean(q);
    if (kicker) kicker.textContent = q ? (items.length ? "Results" : "") : "Suggested";
    if (!items.length) {
      hits.innerHTML = `<p class="search-empty">No matches for “${escapeHtml(q)}”.<br>Try “coat”, “denim” or “leather”.</p>`;
      return;
    }
    const rows = items.map((item) => `
      <a class="search-hit" href="${escapeHtml(item.href)}">
        <span class="search-hit-media">
          <img src="${escapeHtml(item.img || "")}" alt="" width="320" height="400">
        </span>
        <span class="search-hit-info">
          <strong>${escapeHtml(item.title)}</strong>
          <span class="search-hit-price">${escapeHtml(item.price)}</span>
        </span>
      </a>
    `).join("");
    const seeAll = q ? `
      <a class="search-see-all" href="${escapeHtml(searchPageHref(q))}">
        See all results for “${escapeHtml(q)}”
        <svg viewBox="0 0 16 16" aria-hidden="true"><path d="M2.5 8h11M9.5 4l4 4-4 4"/></svg>
      </a>
    ` : "";
    hits.innerHTML = rows + seeAll;
  };

  const setSearchActive = (index) => {
    const rows = [...(search?.querySelectorAll(".search-hit") || [])];
    if (!rows.length) return;
    searchActiveIndex = Math.max(0, Math.min(index, rows.length - 1));
    rows.forEach((row, i) => row.classList.toggle("is-active", i === searchActiveIndex));
    rows[searchActiveIndex]?.scrollIntoView({ block: "nearest" });
  };

  const mapSuggestProduct = (p) => {
    let img = p.image || p.featured_image?.url || p.featured_image || "";
    if (typeof img === "string" && img.includes("cdn.shopify.com") && !/[?&]width=/.test(img)) {
      img += (img.includes("?") ? "&" : "?") + "width=480";
    }
    const href = p.url || (p.handle ? `/products/${p.handle}` : "#");
    let price = p.price;
    if (typeof price === "number") price = formatMoney(Math.round(price * 100));
    else if (price && /^\d+(\.\d+)?$/.test(String(price))) price = formatMoney(Math.round(Number(price) * 100));
    else if (p.price_min) price = formatMoney(p.price_min);
    return { title: p.title || "", price: price || "", href, img };
  };

  let searchTimer;
  const paintSearch = (query) => {
    const q = query.trim();
    if (!q) {
      renderSearchHits(searchSuggest, "");
      return;
    }
    const chips = search?.querySelector("[data-search-chips]");
    if (chips) chips.hidden = true;
    clearTimeout(searchTimer);
    searchTimer = setTimeout(() => {
      const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8`;
      fetch(url, { headers: { Accept: "application/json" } })
        .then((r) => r.json())
        .then((data) => {
          const products = data?.resources?.results?.products || [];
          renderSearchHits(products.map(mapSuggestProduct), q);
        })
        .catch(() => {
          const local = searchSuggest.filter((item) => item.title.toLowerCase().includes(q.toLowerCase()));
          renderSearchHits(local, q);
        });
    }, 160);
  };

  const openSearch = () => {
    html.classList.remove("is-cart-open", "is-menu-open", "is-guide-open");
    cart?.classList.remove("is-open");
    menu?.classList.remove("is-open");
    guide?.classList.remove("is-open");
    shopBtn?.setAttribute("aria-expanded", "false");
    shopBtn?.setAttribute("aria-label", "Shop");
    bagBtn?.setAttribute("aria-expanded", "false");
    setGuideBtn(false);
    header?.classList.remove("is-open");
    search?.classList.add("is-open");
    overlay?.classList.add("is-on");
    html.classList.add("is-search-open");
    setPageInert(true);
    setScrollLock(true);
    menu?.setAttribute("aria-hidden", "true");
    cart?.setAttribute("aria-hidden", "true");
    guide?.setAttribute("aria-hidden", "true");
    search?.setAttribute("aria-hidden", "false");
    searchBtns.forEach((btn) => btn.setAttribute("aria-expanded", "true"));
    paintSearch(searchInput?.value || "");
    focusEl(searchInput);
  };

  const updateBagCount = (n) => {
    document.querySelectorAll(".bag-count").forEach((el) => {
      el.textContent = n ? String(n) : "";
      el.hidden = n === 0;
    });
    if (bagBtn) {
      bagBtn.setAttribute("aria-label", n ? (n === 1 ? "Bag, 1 item" : `Bag, ${n} items`) : "Bag");
    }
    const head = cart?.querySelector("[data-cart-count]");
    if (head) head.textContent = n ? `Bag (${n})` : "Bag";
    cart?.classList.toggle("is-empty", n === 0);
  };

  const cartRemoveSvg = `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6.5 6.5l11 11M17.5 6.5l-11 11"/></svg>`;

  const renderCart = (data) => {
    const body = cart?.querySelector("[data-cart-body]");
    const sub = cart?.querySelector("[data-cart-subtotal]");
    if (!body) return;
    if (!data.items || !data.items.length) {
      body.innerHTML = `<div class="cart-empty">
        <svg class="cart-empty-icon" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M8 8.5V7.25A4 4 0 0 1 12 3.5a4 4 0 0 1 4 3.75V8.5"/>
          <path d="M6.4 8.5h11.2l-.9 11.5H7.3L6.4 8.5z"/>
        </svg>
        <p class="cart-empty-title">Your bag is empty</p>
        <button class="btn-solid cart-empty-back" type="button" data-close>Back</button>
      </div>`;
    } else {
      body.innerHTML = data.items.map((item) => {
        const img = item.image ? item.image.replace(/(\.[^.]+)(\?|$)/, "_200x$1$2") : "";
        const opt = (item.variant_title && item.variant_title !== "Default Title") ? `<p>Size ${item.variant_title}</p>` : "";
        const title = String(item.product_title || "").replace(/</g, "&lt;");
        return `<article class="cart-line">
          <img src="${img}" alt="">
          <div>
            <h3>${title}</h3>
            ${opt}
            <p>Qty ${item.quantity}</p>
            <p class="cart-ship-line">
              <svg class="cart-ship-check" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><circle cx="12" cy="12" r="8.5"/><path d="M8.2 12.1l2.5 2.5 5.1-5.2"/></svg>
              Free shipping
            </p>
          </div>
          <div class="cart-line-side">
            <p class="price">${formatMoney(item.final_line_price)}</p>
            <button class="cart-remove" type="button" data-cart-remove data-line-key="${item.key}" aria-label="Remove ${title}">
              ${cartRemoveSvg}
            </button>
          </div>
        </article>`;
      }).join("");
    }
    if (sub) sub.textContent = formatMoney(data.total_price);
    updateBagCount(data.item_count || 0);
  };

  const refreshCart = () =>
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then((r) => r.json())
      .then(renderCart);

  const addToCart = (id, quantity) => {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id, quantity }),
    }).then((r) => {
      if (!r.ok) throw new Error("add failed");
      return refreshCart();
    }).then(() => openCart());
  };

  cart?.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-cart-remove]");
    if (!btn) return;
    const key = btn.getAttribute("data-line-key");
    if (!key) return;
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: 0 }),
    })
      .then((r) => {
        if (!r.ok) throw new Error("remove failed");
        return r.json();
      })
      .then(renderCart);
  });

  shopBtn?.addEventListener("click", () => {
    if (menu?.classList.contains("is-open")) closeAll();
    else openMenu();
  });
  bagBtn?.addEventListener("click", () => {
    if (cart?.classList.contains("is-open")) closeAll();
    else {
      refreshCart().finally(openCart);
    }
  });
  searchBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      if (search?.classList.contains("is-open")) closeAll();
      else openSearch();
    });
  });
  searchInput?.addEventListener("input", () => {
    paintSearch(searchInput.value);
  });
  search?.querySelector("[data-search-form]")?.addEventListener("submit", (e) => {
    e.preventDefault();
    window.location.href = searchPageHref((searchInput?.value || "").trim());
  });
  searchInput?.addEventListener("keydown", (e) => {
    const rows = [...(search?.querySelectorAll(".search-hit") || [])];
    if (!rows.length) return;
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setSearchActive(searchActiveIndex + 1);
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setSearchActive(searchActiveIndex - 1);
    } else if (e.key === "Enter" && searchActiveIndex >= 0 && rows[searchActiveIndex]) {
      e.preventDefault();
      window.location.href = rows[searchActiveIndex].getAttribute("href");
    }
  });
  search?.querySelectorAll("[data-search-term]").forEach((chip) => {
    chip.addEventListener("click", () => {
      const term = chip.dataset.searchTerm || "";
      if (searchInput) searchInput.value = term;
      paintSearch(term);
      focusEl(searchInput);
    });
  });
  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-open=guide]");
    if (!btn) return;
    e.preventDefault();
    if (guide?.classList.contains("is-open")) closeAll();
    else openGuide();
  });
  // "Find your fit" link on the product page: open the size guide straight on the finder.
  document.addEventListener("click", (e) => {
    if (!e.target.closest("[data-open-finder]")) return;
    e.preventDefault();
    openGuide();
    guide?.querySelector("[data-finder-open]")?.click();
  });
  overlay?.addEventListener("click", closeAll);
  guide?.addEventListener("click", (e) => {
    if (!e.target.closest(".guide-panel")) closeAll();
  });
  search?.addEventListener("click", (e) => {
    if (!e.target.closest(".search-panel")) closeAll();
  });
  document.querySelectorAll("[data-close]").forEach((el) => {
    el.addEventListener("click", closeAll);
  });
  cart?.addEventListener("click", (e) => {
    if (e.target.closest("[data-close]")) closeAll();
  });
  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    if (document.querySelector("[data-atc-size].is-open")) {
      closeSizeMenu();
      return;
    }
    if (guide?.querySelector(".guide-panel.is-finder")) {
      closeFinder();
      focusEl(guide.querySelector("[data-finder-open]"));
      return;
    }
    if (isMobileMenu() && html.classList.contains("is-menu-drill")) {
      const trigger = document.querySelector("#menu [data-fly].is-hot");
      closeFly();
      focusEl(trigger || menuClose);
      return;
    }
    if (document.querySelector("[data-gallery-lightbox]:not([hidden])")) {
      clearGalleryZoom();
      return;
    }
    closeAll();
  });

  const galleryLightbox = () => {
    let box = document.querySelector("[data-gallery-lightbox]");
    if (box) return box;
    box = document.createElement("div");
    box.className = "gallery-lightbox";
    box.hidden = true;
    box.setAttribute("data-gallery-lightbox", "");
    box.setAttribute("role", "dialog");
    box.setAttribute("aria-modal", "true");
    box.setAttribute("aria-label", "Product images");
    const close = document.createElement("button");
    close.type = "button";
    close.className = "gallery-lightbox-close";
    close.setAttribute("aria-label", "Close");
    close.innerHTML = '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M1 1l12 12M13 1L1 13" fill="none" stroke="currentColor" stroke-width="1.2"/></svg>';
    const list = document.createElement("div");
    list.className = "gallery-lightbox-list";
    box.append(close, list);
    close.addEventListener("click", (e) => {
      e.stopPropagation();
      clearGalleryZoom();
    });
    list.addEventListener("click", (e) => {
      if (e.target.closest("img")) clearGalleryZoom();
    });
    document.body.appendChild(box);
    return box;
  };
  const clearGalleryZoom = () => {
    const box = document.querySelector("[data-gallery-lightbox]");
    if (box) {
      box.hidden = true;
      box.scrollTop = 0;
    }
    document.querySelectorAll(".gallery-zoom[aria-pressed='true']").forEach((btn) => {
      btn.setAttribute("aria-pressed", "false");
    });
    document.documentElement.classList.remove("is-gallery-zoomed");
  };
  const openGalleryZoom = (zoom) => {
    const zooms = [...document.querySelectorAll(".gallery-track > figure:not(.is-guide) > .gallery-zoom")];
    const box = galleryLightbox();
    const list = box.querySelector(".gallery-lightbox-list");
    list.replaceChildren();
    let target = null;
    zooms.forEach((btn) => {
      const srcImg = btn.querySelector("img");
      if (!srcImg) return;
      const img = document.createElement("img");
      img.src = srcImg.currentSrc || srcImg.getAttribute("src") || "";
      img.alt = srcImg.alt || "";
      list.appendChild(img);
      if (btn === zoom) target = img;
    });
    box.hidden = false;
    zooms.forEach((btn) => btn.setAttribute("aria-pressed", btn === zoom ? "true" : "false"));
    document.documentElement.classList.add("is-gallery-zoomed");
    if (target) target.scrollIntoView({ block: "start" });
  };
  const mountPage = () => {
    main = document.getElementById("main");
    pdpBar = document.querySelector("[data-pdp-bar]");
    const site = document.querySelector(".site");
    if (pdpBar && site && pdpBar.parentNode !== site) site.appendChild(pdpBar);
    footWrap = document.querySelector(".foot-wrap, .shopify-section-group-footer-group");
    hero = document.querySelector(".hero");
    layers = document.querySelectorAll("[data-parallax]");

    const gallery = document.querySelector("[data-gallery]");
    const dots = document.querySelectorAll("[data-dot]");
    const setDot = (i) => {
      dots.forEach((d, n) => d.classList.toggle("is-on", n === i));
    };
    gallery?.addEventListener("scroll", () => {
      const w = gallery.clientWidth;
      if (!w) return;
      setDot(Math.round(gallery.scrollLeft / w));
    }, { passive: true });
    dots.forEach((d) => {
      d.addEventListener("click", () => {
        const w = gallery?.clientWidth || 0;
        gallery?.scrollTo({ left: Number(d.dataset.dot) * w, behavior: "smooth" });
      });
    });

    const galleryEl = document.querySelector(".gallery");
    const galleryRail = document.querySelector("[data-gallery-rail]");
    if (galleryEl?.classList.contains("is-rail-fixed")) {
      const placeRail = () => {
        const box = galleryEl.getBoundingClientRect();
        const mid = window.innerHeight * 0.5;
        galleryEl.classList.toggle("is-rail-away", box.bottom < mid || box.top > mid);
      };
      placeRail();
      window.addEventListener("scroll", placeRail, { passive: true });
      window.addEventListener("resize", placeRail);
      if ("ResizeObserver" in window) new ResizeObserver(placeRail).observe(galleryEl);
    }
    const galleryFigures = [...document.querySelectorAll(".gallery-track > figure")];
    const pdpSection = galleryEl?.closest(".pdp");
    const buyCol = pdpSection?.querySelector(":scope > .buy");
    const galleryHover = window.matchMedia("(min-width: 901px) and (hover: hover) and (pointer: fine)");
    if (pdpSection && galleryEl && buyCol) {
      let galleryProgress = 0;
      const unlockGallery = () => {
        if (!galleryHover.matches || pdpSection.classList.contains("is-unlocked")) return;
        galleryProgress = Math.max(0, window.scrollY - galleryEl.offsetTop);
        pdpSection.classList.add("is-unlocked");
        window.scrollTo(0, pdpSection.offsetTop);
        galleryEl.scrollTop = galleryProgress;
      };
      const lockGallery = () => {
        if (!galleryHover.matches || !pdpSection.classList.contains("is-unlocked")) return;
        galleryProgress = galleryEl.scrollTop || galleryProgress;
        pdpSection.classList.remove("is-unlocked");
        window.scrollTo(0, galleryEl.offsetTop + galleryProgress);
      };
      buyCol.addEventListener("pointerenter", unlockGallery);
      galleryEl.addEventListener("pointerenter", lockGallery);
      buyCol.addEventListener("wheel", (e) => {
        if (!galleryHover.matches || pdpSection.classList.contains("is-unlocked")) return;
        e.preventDefault();
        unlockGallery();
        window.scrollBy(0, e.deltaY);
      }, { passive: false });
      galleryEl.addEventListener("wheel", (e) => {
        if (!galleryHover.matches || !pdpSection.classList.contains("is-unlocked")) return;
        e.preventDefault();
        lockGallery();
        window.scrollBy(0, e.deltaY);
      }, { passive: false });
    }
    if (galleryEl && galleryRail && galleryFigures.length && "IntersectionObserver" in window) {
      const railThumbs = [...galleryRail.querySelectorAll("[data-rail-thumb]")];
      const activeFigure = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const idx = galleryFigures.indexOf(entry.target);
          if (idx < 0) return;
          railThumbs.forEach((t, i) => t.classList.toggle("is-on", i === idx));
        });
      }, { threshold: 0.55 });
      galleryFigures.forEach((fig) => activeFigure.observe(fig));
      railThumbs.forEach((btn, i) => {
        btn.addEventListener("click", () => {
          clearGalleryZoom();
          galleryFigures[i]?.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
        });
      });
    }

    document.querySelectorAll(".gallery-track > figure:not(.is-guide) > .gallery-zoom").forEach((zoom) => {
      if (zoom.hasAttribute("data-zoom-bound")) return;
      zoom.setAttribute("data-zoom-bound", "");
      zoom.addEventListener("click", () => openGalleryZoom(zoom));
    });

    const accGroup = document.querySelector(".pdp-more-acc");
    if (accGroup) {
      const accs = [...accGroup.querySelectorAll("details.acc")];
      accs.forEach((acc) => {
        acc.addEventListener("toggle", () => {
          if (!acc.open) return;
          accs.forEach((other) => {
            if (other !== acc) other.open = false;
          });
        });
      });
    }

    const qtyInputs = [...document.querySelectorAll("[data-qty-input]")];
    const walletIds = () => document.querySelectorAll("[data-wallet-id]");
    const walletQtys = () => document.querySelectorAll("[data-wallet-qty]");
    const setQty = (n) => {
      const v = String(Math.min(9, Math.max(1, n)));
      qtyInputs.forEach((el) => { el.value = v; });
      walletQtys().forEach((el) => {
        el.value = v;
        el.dispatchEvent(new Event("change", { bubbles: true }));
      });
    };
    document.querySelectorAll("[data-qty-down]").forEach((btn) => {
      btn.addEventListener("click", () => setQty(Number(qtyInputs[0]?.value || 1) - 1));
    });
    document.querySelectorAll("[data-qty-up]").forEach((btn) => {
      btn.addEventListener("click", () => setQty(Number(qtyInputs[0]?.value || 1) + 1));
    });
    qtyInputs.forEach((el) => {
      el.addEventListener("change", () => setQty(Number(el.value) || 1));
    });

    const deliveryEls = document.querySelectorAll("[data-buy-delivery]");
    if (deliveryEls.length) {
      const CUTOFF_HOUR = 14;
      const DELIVERY_ZONES = {
        uk: { region: "the United Kingdom", days: 1 },
        eu: { region: "Europe", days: 3 },
        us: { region: "the United States", days: 4 },
        row: { region: "the rest of the world", days: 7 },
      };
      const detectZone = () => {
        try {
          const country = document.querySelector(".foot-locale summary span")?.textContent || "";
          if (/united kingdom|ireland/i.test(country)) return "uk";
          if (/united states/i.test(country)) return "us";
          const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
          if (tz === "Europe/London" || tz === "Europe/Dublin") return "uk";
          if (tz.startsWith("America/")) return "us";
          if (tz.startsWith("Europe/")) return "eu";
          return "row";
        } catch {
          return "uk";
        }
      };
      const zone = DELIVERY_ZONES[detectZone()] || DELIVERY_ZONES.uk;
      const isWeekend = (d) => d.getDay() === 0 || d.getDay() === 6;
      const addBusinessDays = (date, days) => {
        const d = new Date(date);
        let added = 0;
        while (added < days) {
          d.setDate(d.getDate() + 1);
          if (!isWeekend(d)) added++;
        }
        return d;
      };
      const formatDate = (d) => d.toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short" });
      const dispatchDate = () => {
        const now = new Date();
        const cutoff = new Date(now);
        cutoff.setHours(CUTOFF_HOUR, 0, 0, 0);
        let d = new Date(now);
        if (now >= cutoff) d.setDate(d.getDate() + 1);
        while (isWeekend(d)) d.setDate(d.getDate() + 1);
        return d;
      };
      const dateStr = formatDate(addBusinessDays(dispatchDate(), zone.days));
      deliveryEls.forEach((el) => {
        const dateEl = el.querySelector("[data-delivery-date]");
        const regionEl = el.querySelector("[data-delivery-region]");
        if (dateEl) dateEl.textContent = dateStr;
        if (regionEl) regionEl.textContent = zone.region;
      });
    }

    const sizes = document.querySelectorAll("[data-size]");
    const notify = document.querySelectorAll("[data-notify]");
    const adds = document.querySelectorAll("[data-add]");
    const sizeLabels = document.querySelectorAll("[data-size-label]");
    const variantSelect = document.querySelector("[data-variant-select]");
    const form = document.querySelector("[data-product-form]");
    const priceEl = document.querySelector("[data-product-price]");

    const addLabel = (out, price) => (out ? "Sold out" : `Add To Cart · ${price}`);

    const currentPrice = () => {
      const opt = variantSelect?.selectedOptions[0];
      if (opt?.dataset.price) return formatMoney(opt.dataset.price);
      return priceEl?.dataset.priceFormatted || "";
    };

    const sizeValue = (el) => (el.dataset.sizeValue || el.textContent).trim();
    const setSize = (btn) => {
      const id = btn.dataset.id;
      const val = sizeValue(btn);
      sizes.forEach((s) => {
        const on = id && s.dataset.id ? s.dataset.id === id : sizeValue(s) === val;
        s.classList.toggle("is-on", on);
      });
      const out = btn.classList.contains("is-out") || btn.dataset.available === "false";
      sizeLabels.forEach((el) => { el.textContent = val; });
      if (variantSelect && id) variantSelect.value = id;
      if (id) {
        walletIds().forEach((el) => {
          el.value = id;
          el.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }
      notify.forEach((el) => el.classList.toggle("is-on", out));
      resetNotify();
      html.classList.toggle("is-atc-sold", out);
      const price = currentPrice();
      adds.forEach((add) => {
        add.disabled = out;
        add.classList.remove("is-loading");
        add.removeAttribute("aria-busy");
        const label = add.querySelector("[data-add-label]");
        const text = addLabel(out, price);
        if (label) label.textContent = text;
        else add.textContent = text;
      });
      closeSizeMenu();
    };

    const notified = new Set();
    const notifyVariant = () => variantSelect?.value || "";
    const resetNotify = () => {
      const done = notified.has(notifyVariant());
      notify.forEach((wrap) => {
        const open = wrap.querySelector("[data-notify-open]");
        const form = wrap.querySelector("[data-notify-form]");
        const thanks = wrap.querySelector("[data-notify-done]");
        if (!open || !form || !thanks) return;
        open.hidden = done;
        form.hidden = true;
        thanks.hidden = !done;
        const submit = form.querySelector("button");
        if (submit) {
          submit.disabled = false;
          submit.textContent = "Notify me";
        }
      });
    };

    document.addEventListener("click", (e) => {
      if (!e.target.closest("[data-notify-open]")) return;
      notify.forEach((wrap) => {
        const open = wrap.querySelector("[data-notify-open]");
        const form = wrap.querySelector("[data-notify-form]");
        const thanks = wrap.querySelector("[data-notify-done]");
        if (!open || !form || !thanks || thanks.hidden === false) return;
        open.hidden = true;
        form.hidden = false;
      });
      document.querySelector("[data-notify-form]:not([hidden]) [data-notify-email]")?.focus();
    });

    document.addEventListener("submit", async (e) => {
      const form = e.target.closest?.("[data-notify-form]");
      if (!form) return;
      e.preventDefault();
      const email = form.querySelector("[data-notify-email]")?.value.trim();
      const variant = notifyVariant();
      if (!email || !variant) return;
      const submits = [...document.querySelectorAll("[data-notify-form] button")];
      submits.forEach((button) => { button.disabled = true; });
      try {
        const res = await fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=Vch3zX", {
          method: "POST",
          headers: {
            accept: "application/json",
            "content-type": "application/json",
            revision: "2024-10-15"
          },
          body: JSON.stringify({
            data: {
              type: "back-in-stock-subscription",
              attributes: {
                channels: ["EMAIL"],
                profile: {
                  data: {
                    type: "profile",
                    attributes: { email }
                  }
                }
              },
              relationships: {
                variant: {
                  data: {
                    type: "catalog-variant",
                    id: `$shopify:::$default:::${variant}`
                  }
                }
              }
            }
          })
        });
        if (!res.ok) throw new Error(String(res.status));
        notified.add(variant);
        resetNotify();
      } catch {
        submits.forEach((button) => {
          button.disabled = false;
          button.textContent = "Try again";
        });
      }
    });
    sizes.forEach((btn) => {
      btn.addEventListener("click", () => setSize(btn));
    });
    const initialSize = document.querySelector(".sizes [data-size].is-on") || document.querySelector("[data-size].is-on");
    if (initialSize) {
      html.classList.toggle(
        "is-atc-sold",
        initialSize.classList.contains("is-out") || initialSize.dataset.available === "false"
      );
    }

    // ---- Find your fit ---------------------------------------------------
    // DRAFT body measurements, waiting for Matthew's sign-off before going live.
    // Any product can override them with custom.recommendation_rules (JSON):
    //   { "chest_cm": { "S": 88, "M": 94 },          body chest / bust per size
    //     "waist_cm": { "28": 71 },                   body waist per size (jeans)
    //     "equivalents": { "S": { "womens": "8", "mens": "36" } } }
    // Keys are the size exactly as the variant is named (8, 10, S, M, 28 ...).
    const FIT_DRAFT = {
      // Women's UK size -> bust: 81 cm at UK 8, +5 cm every two sizes.
      womensBust: (uk) => Math.round(81 + (uk - 8) * 2.5),
      // Men's size is chest in inches.
      mensChest: (size) => Math.round(size * 2.54),
      // Jeans size is waist in inches.
      jeansWaist: (size) => Math.round(size * 2.54),
      letterEquivalents: {
        XXS: { womens: "4", mens: "32" },
        XS: { womens: "6", mens: "34" },
        S: { womens: "8", mens: "36" },
        M: { womens: "10", mens: "38" },
        L: { womens: "12", mens: "40" },
        XL: { womens: "14", mens: "42" },
        XXL: { womens: "16", mens: "44" },
      },
    };
    const sizeNum = (value) => {
      const nums = String(value ?? "").match(/\d+(?:\.\d+)?/g);
      if (!nums || nums.length > 2) return null;
      const n = nums.map(Number);
      return n.length === 2 ? (n[0] + n[1]) / 2 : n[0];
    };
    // Men's sizes start at 30+ (chest inches); women's UK sizes sit below that.
    const chestForUk = (uk) => {
      const n = sizeNum(uk);
      if (n == null) return null;
      return n >= 30 ? FIT_DRAFT.mensChest(n) : FIT_DRAFT.womensBust(n);
    };
    const collectSizes = () => {
      const rows = [...document.querySelectorAll("#guide [data-size]")];
      const els = rows.length ? rows : [...document.querySelectorAll("[data-size]")];
      const seen = new Map();
      els.forEach((el) => {
        const label = sizeValue(el);
        if (!label || /^(default title|one size)$/i.test(label)) return;
        const available = el.dataset.available !== "false" && !el.classList.contains("is-out");
        const prev = seen.get(label);
        if (prev) {
          prev.available = prev.available || available;
          return;
        }
        const uk = (el.dataset.uk || "").trim();
        // "To fit ..." column in the product's size table (cm; a range like 86-90 uses the middle).
        const fit = sizeNum(el.dataset.bodyCm);
        seen.set(label, { label, available, chartUk: uk !== label ? uk : "", chartFit: fit && fit > 0 ? fit : null, el });
      });
      return [...seen.values()];
    };
    const readFinderRules = (finder) => {
      try {
        const raw = finder.querySelector("[data-finder-rules]")?.textContent;
        const parsed = raw ? JSON.parse(raw) : {};
        return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
      } catch {
        return {};
      }
    };
    const fitContext = (finder) => ({
      kind: finder.dataset.finderKind || "numeric",
      equiv: finder.dataset.finderEquiv === "true",
      gender: finder.dataset.gender || finder.dataset.finderDefaultGender || "womens",
      rules: readFinderRules(finder),
    });
    // Women's and men's sizes that match a letter size. Order of trust:
    // recommendation_rules metafield > this product's own size chart > draft.
    const equivalentsFor = (size, ctx) => {
      const draft = FIT_DRAFT.letterEquivalents[size.label.toUpperCase()] || {};
      const fromChart = {};
      if (ctx.kind === "letter" && /^\d{1,2}(\s*[-–]\s*\d{1,2})?$/.test(size.chartUk)) {
        fromChart[sizeNum(size.chartUk) >= 30 ? "mens" : "womens"] = size.chartUk.replace(/\s*[-–]\s*/, "–");
      }
      const own = ctx.rules.equivalents?.[size.label] || {};
      return { ...draft, ...fromChart, ...own };
    };
    // Order of trust: "To fit" column in the size table > recommendation_rules > draft.
    const bodyCm = (size, ctx, gender = ctx.gender) => {
      if (size.chartFit != null) return size.chartFit;
      const map = (ctx.kind === "jeans" ? ctx.rules.waist_cm : ctx.rules.chest_cm) || {};
      const own = Number(map[size.label]);
      if (Number.isFinite(own) && own > 0) return own;
      if (ctx.kind === "jeans") {
        const n = sizeNum(size.label);
        return n == null ? null : FIT_DRAFT.jeansWaist(n);
      }
      if (ctx.kind === "letter") return chestForUk(equivalentsFor(size, ctx)[gender]);
      return chestForUk(size.label);
    };
    const sizeName = (size, ctx) => {
      if (ctx.kind === "jeans") return `Size ${size.label}`;
      if (ctx.kind === "letter") return size.label;
      return `UK ${size.label}`;
    };
    const equivText = (size, ctx) => {
      if (!ctx.equiv) return "";
      const eq = equivalentsFor(size, ctx);
      return [eq.womens && `Women’s ${eq.womens}`, eq.mens && `Men’s ${eq.mens}`].filter(Boolean).join(" · ");
    };
    const measureWord = (ctx) => (ctx.kind === "jeans" ? "waist" : "chest");
    // A chest under 65 cm or a waist under 50 cm isn't an adult body measurement. It's
    // usually inches typed in the cm box, or a flat garment number copied from the chart,
    // so we ask rather than guess.
    const readMeasure = (value, unit, ctx) => {
      const n = Number(value);
      if (!Number.isFinite(n) || n <= 0) return { cm: null };
      if (unit === "imperial") return { cm: n * 2.54 };
      return { cm: n, looksLikeInches: n < (ctx.kind === "jeans" ? 50 : 65) };
    };
    const formatMeasure = (cm, unit) => (unit === "imperial" ? `${Number((cm / 2.54).toFixed(1))} in` : `${Math.round(cm)} cm`);
    // "97 cm (38 in)", or the other way round when the shopper is using inches.
    const formatBoth = (cm, unit) => {
      const c = `${Math.round(cm)} cm`;
      const i = `${Math.round(cm / 2.54)} in`;
      return unit === "imperial" ? `${i} (${c})` : `${c} (${i})`;
    };
    // "an 80 cm", "an 18 in", "a 97 cm"
    const article = (text) => (/^(8|11(?!\d)|18(?!\d))/.test(text) ? "an" : "a");
    // How far past the smallest or largest size a measurement can be before we say so.
    const OFF_CHART_CM = 8;
    const offChart = (cm, sizes, ctx) => {
      const pts = sizes.map((s) => ({ size: s, target: bodyCm(s, ctx) }));
      if (cm == null || !pts.length || pts.some((p) => !Number.isFinite(p.target))) return null;
      const lo = pts.reduce((a, b) => (b.target < a.target ? b : a));
      const hi = pts.reduce((a, b) => (b.target > a.target ? b : a));
      if (cm > hi.target + OFF_CHART_CM) return { larger: true, ...hi };
      if (cm < lo.target - OFF_CHART_CM) return { larger: false, ...lo };
      return null;
    };
    const toCm = (value, unit) => {
      const n = Number(value);
      if (!Number.isFinite(n) || n <= 0) return null;
      return unit === "imperial" ? n * 2.54 : n;
    };
    const heightToCm = (form, unit) => {
      if (unit === "metric") return toCm(form.querySelector("[data-finder-height]")?.value, "metric");
      const ft = Number(form.querySelector("[data-finder-ft]")?.value);
      const inch = Number(form.querySelector("[data-finder-in]")?.value);
      const totalIn = (Number.isFinite(ft) ? ft : 0) * 12 + (Number.isFinite(inch) ? inch : 0);
      return totalIn > 0 ? totalIn * 2.54 : null;
    };
    // Height and weight are collected but deliberately do not change the size.
    const recommendSize = ({ usual, measured, fit, sizes, profile, ctx }) => {
      if (!usual && measured == null) {
        return { error: ctx.kind === "jeans" ? "Choose your usual jeans size or enter your waist." : "Choose your usual size or enter your chest." };
      }
      if (!sizes.length) return { error: "This product has no sizes to recommend yet." };
      const targets = sizes.map((s) => bodyCm(s, ctx));
      const canMeasure = measured != null && targets.every((t) => Number.isFinite(t));
      let idx;
      if (canMeasure) {
        idx = 0;
        let dist = Infinity;
        targets.forEach((t, i) => {
          const d = Math.abs(measured - t);
          if (d < dist) {
            dist = d;
            idx = i;
          }
        });
        for (let i = 0; i < targets.length - 1; i++) {
          if (measured > targets[i] && measured < targets[i + 1]) {
            if (fit === "closer") idx = i;
            else if (fit === "relaxed") idx = i + 1;
            else idx = measured < (targets[i] + targets[i + 1]) / 2 ? i : i + 1;
            break;
          }
        }
      } else if (usual) {
        idx = Math.max(0, sizes.findIndex((s) => s.label === usual));
        if (fit === "closer") idx = Math.max(0, idx - 1);
        if (fit === "relaxed") idx = Math.min(sizes.length - 1, idx + 1);
      } else {
        return { error: `We can’t match a ${measureWord(ctx)} measurement on this piece yet. Choose your usual size instead.` };
      }
      const profileShift = profile === "runs_small" ? 1 : profile === "relaxed" ? -1 : 0;
      idx = Math.max(0, Math.min(sizes.length - 1, idx + profileShift));
      return { primary: sizes[idx], usedMeasure: canMeasure };
    };
    const applyRecommendation = (rec, ctx) => {
      const { primary } = rec;
      const match = primary.el?.isConnected
        ? primary.el
        : [...document.querySelectorAll("[data-size]")].find((el) => sizeValue(el) === primary.label);
      document.querySelectorAll("#guide [data-size].is-rec").forEach((el) => el.classList.remove("is-rec"));
      if (match) {
        match.classList.add("is-rec");
        setSize(match);
      }
      const badge = guide?.querySelector("[data-finder-badge]");
      if (badge) {
        const span = (cls, text) => {
          const el = document.createElement("span");
          el.className = cls;
          el.textContent = text;
          return el;
        };
        const notes = [
          equivText(primary, ctx),
          !primary.available && "Currently unavailable",
        ].filter(Boolean);
        badge.replaceChildren(
          span("guide-rec-kicker", "Your recommendation"),
          span("guide-rec-size", sizeName(primary, ctx)),
          ...notes.map((n) => span("guide-rec-note", n))
        );
        badge.hidden = false;
      }
      // Product page link now reads e.g. "Recommended size: M".
      document.querySelectorAll("[data-finder-pdp-label]").forEach((el) => {
        el.textContent = `Recommended size: ${ctx.kind === "jeans" ? primary.label : sizeName(primary, ctx)}`;
      });
      closeFinder();
      focusEl(match || guide?.querySelector("[data-finder-open]"));
    };
    const mountFinder = () => {
      const finder = guide?.querySelector("[data-finder]");
      const form = finder?.querySelector("[data-finder-form]");
      if (!finder || !form || form.dataset.ready === "true") return;
      form.dataset.ready = "true";
      document.querySelectorAll("[data-open-finder]").forEach((el) => { el.hidden = false; });
      const usual = form.querySelector("[data-finder-usual]");
      const sizes = collectSizes();
      // Default to the sizing this product's own chart is written in (UK 8-16 =
      // women's, 34-44 = men's); product tags are only a fallback.
      if (finder.dataset.finderKind === "letter" && finder.dataset.finderGenderFixed !== "true") {
        const chartN = sizes.map((s) => sizeNum(s.chartUk)).find((n) => n != null);
        if (chartN != null) finder.dataset.finderDefaultGender = chartN >= 30 ? "mens" : "womens";
      }
      const baseCtx = fitContext(finder);
      sizes.forEach((size) => {
        const opt = document.createElement("option");
        opt.value = size.label;
        const name = baseCtx.kind === "jeans" ? size.label : sizeName(size, baseCtx);
        const eq = equivText(size, baseCtx);
        opt.textContent = eq ? `${name} (${eq})` : name;
        usual?.append(opt);
      });
      form.querySelectorAll("input[name=gender]").forEach((radio) => {
        radio.checked = radio.value === baseCtx.gender;
        radio.addEventListener("change", () => {
          if (radio.checked) finder.dataset.gender = radio.value;
        });
      });
      finder.dataset.gender = baseCtx.gender;
      const setUnit = (unit) => {
        finder.dataset.unit = unit;
        form.querySelectorAll("[data-finder-unit]").forEach((btn) => {
          const on = btn.dataset.finderUnit === unit;
          btn.classList.toggle("is-on", on);
          btn.setAttribute("aria-pressed", on ? "true" : "false");
        });
        const chestUnit = form.querySelector("[data-finder-chest-unit]");
        const weightUnit = form.querySelector("[data-finder-weight-unit]");
        const metricH = form.querySelector("[data-finder-height-metric]");
        const imperialH = form.querySelector("[data-finder-height-imperial]");
        if (chestUnit) chestUnit.textContent = unit === "imperial" ? "in" : "cm";
        if (weightUnit) weightUnit.textContent = unit === "imperial" ? "lb" : "kg";
        if (metricH) metricH.hidden = unit === "imperial";
        if (imperialH) imperialH.hidden = unit !== "imperial";
      };
      setUnit("metric");
      form.querySelectorAll("[data-finder-unit]").forEach((btn) => {
        btn.addEventListener("click", () => {
          const next = btn.dataset.finderUnit;
          const prev = finder.dataset.unit || "metric";
          if (next === prev) return;
          const chest = form.querySelector("[data-finder-chest]");
          const weight = form.querySelector("[data-finder-weight]");
          const height = form.querySelector("[data-finder-height]");
          const ft = form.querySelector("[data-finder-ft]");
          const inch = form.querySelector("[data-finder-in]");
          if (chest?.value) {
            const cm = toCm(chest.value, prev);
            chest.value = next === "imperial" ? (cm / 2.54).toFixed(1) : String(Math.round(cm));
          }
          if (weight?.value) {
            const kg = prev === "imperial" ? Number(weight.value) / 2.2046 : Number(weight.value);
            weight.value = next === "imperial" ? (kg * 2.2046).toFixed(1) : String(Math.round(kg));
          }
          if (next === "imperial") {
            const cm = toCm(height?.value, "metric");
            if (cm) {
              const totalIn = cm / 2.54;
              if (ft) ft.value = String(Math.floor(totalIn / 12));
              if (inch) inch.value = String(Math.round(totalIn % 12));
            }
          } else {
            const cm = heightToCm(form, "imperial");
            if (height && cm) height.value = String(Math.round(cm));
          }
          setUnit(next);
        });
      });
      // Three steps: 1 usual size, 2 measurements, 3 preferred fit.
      const steps = [...form.querySelectorAll("[data-finder-step]")];
      const nextBtn = form.querySelector("[data-finder-next]");
      const backLabel = finder.querySelector("[data-finder-back-label]");
      let step = 1;
      const showError = (text) => {
        const error = finder.querySelector("[data-finder-error]");
        if (!error) return;
        error.hidden = !text;
        error.textContent = text || "";
      };
      const showStep = (n, focus = true) => {
        step = Math.max(1, Math.min(steps.length || 1, n));
        steps.forEach((el) => { el.hidden = Number(el.dataset.finderStep) !== step; });
        const num = finder.querySelector("[data-finder-step-num]");
        const bar = finder.querySelector("[data-finder-step-bar]");
        if (num) num.textContent = String(step);
        if (bar) bar.style.width = `${(step / (steps.length || 1)) * 100}%`;
        if (nextBtn) nextBtn.textContent = step < steps.length ? "Continue" : "See recommendation";
        if (backLabel) backLabel.textContent = step > 1 ? "Back" : "Size chart";
        showError("");
        if (focus) focusEl(steps[step - 1]?.querySelector("select, input:not([type=radio]), input[type=radio]:checked"));
      };
      showStep(1, false);
      guide.querySelector("[data-finder-open]")?.addEventListener("click", () => {
        const panel = guide.querySelector(".guide-panel");
        const title = document.getElementById("guide-title");
        panel?.classList.add("is-finder");
        finder.hidden = false;
        finder.setAttribute("aria-hidden", "false");
        if (title) title.textContent = "Find your fit";
        showStep(1);
      });
      finder.querySelector("[data-finder-back]")?.addEventListener("click", () => {
        if (step > 1) {
          showStep(step - 1);
          return;
        }
        closeFinder();
        focusEl(guide.querySelector("[data-finder-open]"));
      });
      const measureInput = form.querySelector("[data-finder-chest]");
      const hasUsual = () => Boolean(usual?.value && usual.value !== "unsure");
      measureInput?.addEventListener("input", () => showError(""));
      // "54 cm looks too small for a chest. Did you mean inches?  [Use inches]"
      const askInches = (value, ctx) => {
        const error = finder.querySelector("[data-finder-error]");
        if (!error) return;
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "finder-error-action";
        btn.textContent = "Use inches";
        btn.addEventListener("click", () => {
          setUnit("imperial");
          // Let this click finish first: removing the button mid-click makes the size
          // guide think the click landed outside its panel, and it closes.
          window.setTimeout(() => {
            showError("");
            form.requestSubmit();
          }, 0);
        });
        error.replaceChildren(`${value} cm looks too small for a ${measureWord(ctx)}. Did you mean inches?`, " ", btn);
        error.hidden = false;
      };
      // Checks step 2's answers; shows a message and returns false if something needs fixing.
      const checkMeasure = () => {
        const ctx = fitContext(finder);
        const unit = finder.dataset.unit || "metric";
        const word = measureWord(ctx);
        const measure = readMeasure(measureInput?.value, unit, ctx);
        if (measure.cm == null) {
          if (hasUsual()) return true;
          showError(ctx.kind === "jeans" ? "Enter your waist, or go back and choose your usual jeans size." : `Enter your ${word}, or go back and choose your usual size.`);
          return false;
        }
        if (measure.looksLikeInches) {
          askInches(measureInput.value, ctx);
          return false;
        }
        const off = offChart(measure.cm, collectSizes(), ctx);
        if (off) {
          const typed = formatMeasure(measure.cm, unit);
          const first = `${article(typed) === "an" ? "An" : "A"} ${typed} ${word} is ${off.larger ? "larger than our biggest" : "smaller than our smallest"} size in this style: ${sizeName(off.size, ctx)} fits a ${word} of about ${formatBoth(off.target, unit)}.`;
          showError(`${first} ${hasUsual() ? "Clear it to go by your usual size instead." : "Please check the number."}`);
          return false;
        }
        return true;
      };
      form.addEventListener("submit", (e) => {
        e.preventDefault();
        if (step === 1) {
          showStep(2);
          return;
        }
        if (step === 2) {
          if (checkMeasure()) showStep(3);
          return;
        }
        if (!checkMeasure()) {
          showStep(2);
          checkMeasure();
          return;
        }
        const error = finder.querySelector("[data-finder-error]");
        const unit = finder.dataset.unit || "metric";
        const ctx = fitContext(finder);
        const usualVal = usual?.value;
        const measure = readMeasure(measureInput?.value, unit, ctx);
        const fit = form.querySelector("input[name=fit]:checked")?.value || "regular";
        const rec = recommendSize({
          usual: usualVal && usualVal !== "unsure" ? usualVal : null,
          measured: measure.cm,
          fit,
          sizes: collectSizes(),
          profile: finder.dataset.fitProfile || "true_to_size",
          ctx,
        });
        if (rec.error) {
          if (error) {
            error.hidden = false;
            error.textContent = rec.error;
          }
          return;
        }
        if (error) {
          error.hidden = true;
          error.textContent = "";
        }
        applyRecommendation(rec, ctx);
      });
    };
    mountFinder();

    const addNow = () => {
      const id = Number(variantSelect?.value);
      const qty = Number(qtyInputs[0]?.value || 1);
      const on = document.querySelector(".sizes [data-size].is-on") || document.querySelector("[data-size].is-on");
      if (on && (on.classList.contains("is-out") || on.dataset.available === "false")) return;
      if (!id) return;
      if ([...adds].some((add) => add.classList.contains("is-loading"))) return;
      adds.forEach((add) => {
        add.classList.add("is-loading");
        add.setAttribute("aria-busy", "true");
      });
      addToCart(id, qty)
        .catch(() => form?.submit())
        .finally(() => {
          adds.forEach((add) => {
            add.classList.remove("is-loading");
            add.removeAttribute("aria-busy");
          });
        });
    };

    form?.addEventListener("submit", (e) => {
      e.preventDefault();
      addNow();
    });
    adds.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        addNow();
      });
    });

    atcSizeAbort?.abort();
    atcSizeAbort = new AbortController();
    const sizeSig = { signal: atcSizeAbort.signal };
    document.querySelectorAll("[data-atc-size]").forEach((sizeWrap) => {
      const sizeToggle = sizeWrap.querySelector("[data-atc-size-toggle]");
      const sizeMenu = sizeWrap.querySelector("[data-atc-size-menu]");
      sizeToggle?.addEventListener("click", (e) => {
        e.stopPropagation();
        const open = sizeWrap.classList.contains("is-open");
        closeSizeMenu();
        if (open) return;
        sizeWrap.classList.add("is-open");
        sizeToggle.setAttribute("aria-expanded", "true");
        sizeMenu?.removeAttribute("hidden");
      }, sizeSig);
    });
    document.addEventListener("click", (e) => {
      if (!e.target.closest("[data-atc-size]")) closeSizeMenu();
    }, sizeSig);

    atcIo?.disconnect();
    if (atcOnScroll) {
      window.removeEventListener("scroll", atcOnScroll);
      window.removeEventListener("resize", atcOnScroll);
      atcOnScroll = null;
    }
    setAtcBar(false);
    const pdp = document.querySelector(".pdp");
    const buyRow = document.querySelector("[data-buy-row]");
    const buyHold = document.querySelector("[data-buy-hold]");
    if (pdp && buyRow && pdpBar) {
      const syncAtc = () => {
        const bottom = pdp.getBoundingClientRect().bottom;
        const barH = Math.max(pdpBar?.offsetHeight || 84, 1);
        let progress = (window.innerHeight - bottom) / barH;
        progress = Math.min(1, Math.max(0, progress));
        if (reduceMotion) progress = progress >= 0.5 ? 1 : 0;

        const pin = progress > 0;
        if (pin && !html.classList.contains("is-atc-bar") && buyHold) {
          buyHold.style.height = `${buyRow.getBoundingClientRect().height}px`;
        }
        if (!pin && buyHold) buyHold.style.height = "";
        setAtcBar(pin);
        html.classList.toggle("is-atc-full", progress >= 1);
        if (progress < 1) closeSizeMenu();
        pdpBar.style.setProperty("--atc-scrub", `${((1 - progress) * 100).toFixed(2)}%`);
      };
      atcOnScroll = syncAtc;
      atcIo = new IntersectionObserver(syncAtc, { threshold: [0, 0.05, 0.5, 1] });
      atcIo.observe(pdp);
      window.addEventListener("scroll", syncAtc, { passive: true });
      window.addEventListener("resize", syncAtc);
      syncAtc();
    }

    mountPlp();
    mountSearchPage();

    document.querySelectorAll("[data-newsletter]").forEach((formEl) => {
      formEl.addEventListener("submit", () => {
        /* Shopify customer form posts normally */
      });
    });

    paintParallax();
  };

  // Search results page: keep the overlay input in sync with the query.
  const mountSearchPage = () => {
    const grid = document.querySelector("[data-search-grid]");
    const empty = document.querySelector("[data-search-empty]");
    if (!grid && !empty) return;
    const q = new URLSearchParams(location.search).get("q")?.trim() || "";
    if (searchInput && q) searchInput.value = q;
  };

  // Collection page: category chips + sort work on the rendered cards,
  // exactly as in the mockup (no round-trip to the server).
  const mountPlp = () => {
    const grid = document.querySelector("[data-plp-grid]");
    const countEl = document.querySelector("[data-plp-count]");
    const emptyEl = document.querySelector("[data-plp-empty]");
    const sortEl = document.querySelector("[data-plp-sort]");
    const filters = [...document.querySelectorAll("[data-plp-filter]")];
    if (!grid) return;
    const cards = [...grid.querySelectorAll("[data-plp-card]")];
    const cardWords = (card) => (card.dataset.tags || card.dataset.cat || "").toLowerCase();
    const words = (s) => (s || "").split(",").map((w) => w.trim().toLowerCase().replace(/\s+/g, "-")).filter(Boolean);
    const known = new Set(filters.map((btn) => btn.dataset.plpFilter));
    const matches = (card, btn) => {
      if (!btn || btn.dataset.plpFilter === "all") return true;
      const hay = cardWords(card);
      const inc = words(btn.dataset.plpMatch);
      const exc = words(btn.dataset.plpExclude);
      if (!inc.length) return hay.split("|").includes(btn.dataset.plpFilter);
      if (exc.some((w) => hay.includes(w))) return false;
      return inc.some((w) => hay.includes(w));
    };
    let cat = "all";
    const hash = location.hash.replace("#", "");
    if (hash && known.has(hash)) cat = hash;

    const paint = () => {
      const order = sortEl?.value || "featured";
      const active = filters.find((btn) => btn.dataset.plpFilter === cat);
      const visible = cards.filter((card) => cat === "all" || matches(card, active));
      visible.sort((a, b) => {
        if (order === "price-asc") return Number(a.dataset.price) - Number(b.dataset.price);
        if (order === "price-desc") return Number(b.dataset.price) - Number(a.dataset.price);
        return Number(a.dataset.i) - Number(b.dataset.i);
      });
      cards.forEach((card) => { card.hidden = !visible.includes(card); });
      visible.forEach((card) => grid.appendChild(card));
      const n = visible.length;
      if (countEl) countEl.textContent = n === 1 ? "1 piece" : `${n} pieces`;
      if (emptyEl) emptyEl.hidden = n > 0;
    };

    filters.forEach((btn) => {
      const on = btn.dataset.plpFilter === cat;
      btn.classList.toggle("is-on", on);
      btn.setAttribute("aria-pressed", on ? "true" : "false");
      btn.addEventListener("click", () => {
        cat = btn.dataset.plpFilter;
        filters.forEach((other) => {
          const active = other === btn;
          other.classList.toggle("is-on", active);
          other.setAttribute("aria-pressed", active ? "true" : "false");
        });
        paint();
      });
    });
    document.querySelector("[data-plp-title]")?.addEventListener("click", () => {
      document.querySelector('[data-plp-filter="all"]')?.click();
      if (location.hash) history.replaceState(history.state, "", location.pathname + location.search);
    });
    sortEl?.addEventListener("change", paint);
    window.addEventListener("hashchange", () => {
      const next = location.hash.replace("#", "");
      if (next && known.has(next)) document.querySelector(`[data-plp-filter="${next}"]`)?.click();
    });
    paint();
  };

  document.addEventListener("click", (e) => {
    const a = e.target.closest("a[href]");
    if (!a || e.defaultPrevented) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    const raw = a.getAttribute("href") || "";
    if (raw.startsWith("#") && raw.length > 1) {
      const el = document.getElementById(decodeURIComponent(raw.slice(1)));
      if (!el) return;
      e.preventDefault();
      el.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
      history.replaceState(history.state, "", raw);
    }
  });

  let ticking = false;
  let lastY = window.scrollY;
  const headerLocked = () =>
    html.classList.contains("is-cart-open") ||
    html.classList.contains("is-menu-open") ||
    html.classList.contains("is-guide-open") ||
    html.classList.contains("is-search-open");

  const paintHeader = () => {
    if (!header) return;
    const y = Math.max(0, window.scrollY);
    if (headerLocked()) {
      lastY = y;
      return;
    }
    const delta = y - lastY;
    const productPage = document.body.classList.contains("template-product");
    if (productPage) {
      header.classList.remove("is-light");
    } else if (y <= 24) {
      header.classList.remove("is-light");
    } else if (delta < -6) {
      header.classList.add("is-light");
    } else if (delta > 6) {
      header.classList.remove("is-light");
    }
    lastY = y;
    if (footWrap) {
      header.classList.toggle("is-over-foot", footWrap.getBoundingClientRect().top < 72);
    }
  };

  const paintParallax = () => {
    ticking = false;
    paintHeader();
    if (reduceMotion) return;
    layers.forEach((el) => {
      const wrap = el.closest("[data-parallax-wrap]") || el.parentElement;
      if (!wrap) return;
      const speed = Number(el.dataset.parallaxSpeed) || 0.15;
      const r = wrap.getBoundingClientRect();
      const delta = (window.innerHeight / 2 - (r.top + r.height / 2)) / window.innerHeight;
      el.style.transform = `translate3d(0, ${(delta * speed * 100).toFixed(2)}%, 0)`;
    });
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(paintParallax);
  };
  window.addEventListener("scroll", onScroll, { passive: true });

  const consentEl = document.getElementById("consent");
  const CONSENT_KEY = "hegarty-consent";
  const readLocalConsent = () => {
    try { return localStorage.getItem(CONSENT_KEY); } catch { return null; }
  };
  const writeLocalConsent = (value) => {
    try { localStorage.setItem(CONSENT_KEY, value); } catch {}
  };
  const showConsent = () => {
    consentEl?.classList.add("is-on");
    consentEl?.setAttribute("aria-hidden", "false");
  };
  const hideConsent = () => {
    consentEl?.classList.remove("is-on");
    consentEl?.setAttribute("aria-hidden", "true");
  };
  const loadPrivacyApi = (done) => {
    const ready = window.Shopify?.customerPrivacy;
    if (ready?.setTrackingConsent) {
      done(ready);
      return;
    }
    if (!window.Shopify?.loadFeatures) {
      done(null);
      return;
    }
    window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], (err) => {
      done(err ? null : window.Shopify.customerPrivacy || null);
    });
  };
  const setConsent = (allow) => {
    writeLocalConsent(allow ? "all" : "necessary");
    hideConsent();
    loadPrivacyApi((api) => {
      if (!api?.setTrackingConsent) return;
      api.setTrackingConsent({
        analytics: allow,
        marketing: allow,
        preferences: allow,
        sale_of_data: allow
      }, () => {});
    });
  };
  const consentAnswered = (api) => {
    if (readLocalConsent()) return true;
    const current = api?.currentVisitorConsent?.() || api?.getTrackingConsent?.();
    if (!current) return false;
    const analytics = current.analytics;
    return analytics === true || analytics === false || analytics === "yes" || analytics === "no";
  };
  const initConsent = () => {
    loadPrivacyApi((api) => {
      const local = readLocalConsent();
      if (local === "all" || local === "necessary") return;
      if (consentAnswered(api)) return;
      if (typeof api?.shouldShowGDPRBanner === "function" && !api.shouldShowGDPRBanner() && api.userCanBeTracked?.()) return;
      window.setTimeout(showConsent, 400);
    });
  };
  document.addEventListener("click", (e) => {
    const open = e.target.closest("[data-open=cookies]");
    if (open) {
      e.preventDefault();
      showConsent();
      return;
    }
    const btn = e.target.closest("[data-consent]");
    if (!btn) return;
    setConsent(btn.getAttribute("data-consent") === "all");
  });
  initConsent();

  const syncConsentClearance = () => {
    const open = !!consentEl?.classList.contains("is-on");
    const height = open ? Math.ceil(consentEl.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty("--consent-bar", `${height}px`);
  };
  syncConsentClearance();
  if (consentEl) {
    new MutationObserver(syncConsentClearance).observe(consentEl, { attributes: true, attributeFilter: ["class"] });
    if ("ResizeObserver" in window) new ResizeObserver(syncConsentClearance).observe(consentEl);
  }
  window.addEventListener("resize", syncConsentClearance);

  const guideUnits = [...(guide?.querySelectorAll("[data-guide-unit]") || [])];
  const setGuideUnit = (unit) => {
    if (!guide) return;
    guide.dataset.measure = unit;
    guideUnits.forEach((btn) => {
      const on = btn.dataset.guideUnit === unit;
      btn.classList.toggle("is-on", on);
      btn.setAttribute("aria-pressed", on ? "true" : "false");
    });
    guide.querySelectorAll("[data-cm]").forEach((cell) => {
      const cm = Number(String(cell.dataset.cm).replace(",", "."));
      if (!Number.isFinite(cm)) return;
      cell.textContent = unit === "imperial" ? String(Math.round(cm / 2.54)) : String(cm);
    });
    guide.querySelectorAll(".guide-unit").forEach((el) => {
      el.textContent = unit === "imperial" ? "(in)" : "(cm)";
    });
  };
  guideUnits.forEach((btn) => {
    btn.addEventListener("click", () => setGuideUnit(btn.dataset.guideUnit || "metric"));
  });
  const guideScroll = guide?.querySelector("[data-guide-scroll] .guide-table-wrap");
  guideScroll?.addEventListener("scroll", syncGuideScroll, { passive: true });
  window.addEventListener("resize", syncGuideScroll);

  if (location.hash === "#menu") openMenu();
  if (location.hash === "#cart") openCart();
  if (location.hash === "#size-guide") openGuide();
  if (location.hash === "#details") {
    document.getElementById("details")?.scrollIntoView();
  }
  if (location.hash === "#featured") {
    document.querySelector(".featured")?.scrollIntoView();
  }

  mountPage();
})();
